import { render, staticRenderFns } from "./collect_question.vue?vue&type=template&id=42288cc4&scoped=true&"
import script from "./collect_question.vue?vue&type=script&lang=js&"
export * from "./collect_question.vue?vue&type=script&lang=js&"
import style0 from "./collect_question.vue?vue&type=style&index=0&id=42288cc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42288cc4",
  null
  
)

export default component.exports